export const financeQueryKeys = {
  teamRoleRates: {
    all: () => ['team-role-rates'],
    bulk: (teamRoleIds: number[]) => [
      ...financeQueryKeys.teamRoleRates.all(),
      'bulk',
      [...teamRoleIds].sort((a, b) => a - b),
    ],
  },
  organizationCurrency: {
    all: (organizationId: string) => ['organization-currency', organizationId],
  },
  itemFinancials: {
    all: () => ['item-financials'],
    byItemId: (itemId: number) => [...financeQueryKeys.itemFinancials.all(), 'byItemId', itemId],
    bulk: (itemIds: number[]) => [
      ...financeQueryKeys.itemFinancials.all(),
      'bulk',
      [...itemIds].sort((a, b) => a - b),
    ],
  },
  itemFinancialsAggregate: {
    all: () => ['item-financials-aggregate'],
    bulk: (itemIds: number[]) => [
      ...financeQueryKeys.itemFinancialsAggregate.all(),
      'bulk',
      [...itemIds].sort((a, b) => a - b),
    ],
    // Rooted at the same `all()` as `bulk` so a finance-recompute invalidation of `all()` also
    // catches LoopFinancialsTable's per-page top-level cache (useLoopFinancialsPagedQuery's tier
    // 1), not just the eager `bulk` query. Tier 1 only — that hook's descendant tier lives outside
    // the query client and is refreshed separately, via `actualCostRefreshSignal`.
    paged: (datasetSignature: string, pageIndex: number) => [
      ...financeQueryKeys.itemFinancialsAggregate.all(),
      'paged',
      datasetSignature,
      pageIndex,
    ],
  },
  loopFinancials: {
    all: () => ['loop-financials'],
    bulk: (loopIds: number[]) => [
      ...financeQueryKeys.loopFinancials.all(),
      'bulk',
      [...loopIds].sort((a, b) => a - b),
    ],
  },
};
